export default {
  path: '/wecode/priviledge',
  auth: false,
  preload: false,
  key: 'form',
  isStatic: true,
  component: () => import('./index')
};
